export enum EntityName {
  ConstructionSite = 'ConstructionSite',
  UserGroupToUser = 'UserGroupToUser',
  ConstructionSiteUsageStatistic = 'ConstructionSiteUsageStatistic',
  TimeTrackingActivityCompilation = 'TimeTrackingActivityCompilation',
  TimeTrackingConfiguration = 'TimeTrackingConfiguration',
  TimeTrackingActivity = 'TimeTrackingActivity',
  WorkTimeEntry = 'WorkTimeEntry',
  User = 'User',
  UserGroup = 'UserGroup',
}